exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "calendar-inline-card .inline-card{background-color:#fff;width:234px;height:60px;box-shadow:0 1px 3px 0 hsla(220,8%,92%,.5);padding-top:11px;padding-left:20px}calendar-inline-card .title{max-width:140px;max-height:17px;font-family:Stag Sans;font-size:14.5px;color:#0072c9;position:relative;bottom:38px;left:55px;cursor:pointer;text-transform:capitalize;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}calendar-inline-card .day-count{width:122.7px;height:12px;font-family:Stag Sans;font-size:12px;font-weight:300;position:relative;color:#666;bottom:35px;margin-left:55px}calendar-inline-card .day-count .days{font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineCard/calendarInlineCard.scss
// module id = 1484
// module chunks = 0